module.exports = __webpack_public_path__ + "static/img/salon_question_zh-2.6a0ba7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_question_zh-2.png
// module id = lHgc
// module chunks = 34